import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { Line } from "@antv/g2plot";
import chartMixin from "../mixin/chartMixin";
export default {
  name: "ActiveHouseChart",
  mixins: [chartMixin],
  props: {
    cityList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      city: []
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    getPostChartData: function getPostChartData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$city;
        var cites, param;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              cites = _this.city.length ? (_this$city = _this.city) === null || _this$city === void 0 || (_this$city = _this$city.map(function (city) {
                return city.replace(/\s+/g, "");
              })) === null || _this$city === void 0 || (_this$city = _this$city.join(",")) === null || _this$city === void 0 ? void 0 : _this$city.toLocaleLowerCase() : "";
              param = {
                chartName: "ads_house_active_house_chart",
                grain: _this.communityGrain,
                groupBy: "",
                start: _this.dateTime[0],
                end: _this.dateTime[1],
                valueName: "num"
              };
              if (cites) {
                param.city = cites;
              }
              return _context.a(2, new Promise(function (resolve, reject) {
                _this.$api.getPostChartData(param).then(function (res) {
                  var data = res.data.map(function (item) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      city: (item === null || item === void 0 ? void 0 : item.city) || '全部'
                    });
                  });
                  resolve(data);
                }).catch(function (err) {
                  reject([]);
                });
              }));
          }
        }, _callee);
      }))();
    },
    init: function init() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _context2.n = 1;
              return _this2.getPostChartData();
            case 1:
              data = _context2.v;
              _this2.loading = false;
              if (_this2.lineChart) {
                _this2.lineChart.changeData(data);
              } else {
                _this2.lineChart = new Line("container-active-house", {
                  data: data,
                  xField: "time",
                  yField: "num",
                  seriesField: "city",
                  legend: {
                    position: "top",
                    offsetY: 70
                  },
                  smooth: true,
                  appendPadding: [70, 0, 0, 0]
                });
                _this2.lineChart.render();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    command: function command(type) {
      this.communityGrain = type;
      this.init();
    }
  }
};